var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.5C4.0875 16.5 3.7345 16.3533 3.441 16.0597C3.1475 15.7662 3.0005 15.413 3 15V3C3 2.5875 3.147 2.2345 3.441 1.941C3.735 1.6475 4.088 1.5005 4.5 1.5H13.5C13.9125 1.5 14.2657 1.647 14.5597 1.941C14.8538 2.235 15.0005 2.588 15 3V15C15 15.4125 14.8533 15.7657 14.5597 16.0597C14.2662 16.3538 13.913 16.5005 13.5 16.5H4.5ZM8.25 8.25L10.125 7.125L12 8.25V3H8.25V8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.0275c58c3ffae8121a196c4b833912f4.svg";
export { ForwardRef as ReactComponent };